module.exports = __webpack_public_path__ + "static/media/rear_corner.5629f1dd.png";